import AUTH from './auth.api';
import ASSIGNMENTS from './assignments.api';
import SETTINGS from './settings.api';
import LECTURERS from './lecturers.api';
import USERS from './users.api';
import PRIVILEGES from './privileges.api';
import PERMISSIONS from './permissions.api';
import EXCEL from './excel.api';
import STUDENTS from './students.api';
import GRADUATES from './graduates.api';
import COMMANDS from './commands.api';
import ADMISSION from './admission.api';
import LIBRARY from './library.api';
import CURRICULUM from './curriculum.api';
import NOTIFICATIONS from './notifications.api';
import EXAMS from './exams.api';
import ATTENDANCE from './attendance.api';
import ARCHIVE from './archive.api';
import REPORTS from './reports.api';
import LOG from './log.api';
import CHAT from './chat.api';
import LIBRARY_REPORTS from './libraryReports.api';
import RATING from './rating.api';
import RATING_REPORTS from './ratingReports.api';
import CLUBS from './clubs.api';
import CAREER_CENTER from './career_center.api';
const APP_API = {
	AUTH,
	ASSIGNMENTS,
	SETTINGS,
	LECTURERS,
	USERS,
	PRIVILEGES,
	PERMISSIONS,
	EXCEL,
	STUDENTS,
	GRADUATES,
	COMMANDS,
	ADMISSION,
	CURRICULUM,
	NOTIFICATIONS,
	EXAMS,
	ARCHIVE,
	REPORTS,
	ATTENDANCE,
	LOG,
	CHAT,
	LIBRARY,
	LIBRARY_REPORTS,
	RATING,
	RATING_REPORTS,
	CLUBS,
	CAREER_CENTER
};

export default APP_API;
